import React, { PropTypes, Component } from 'react';
import classNames from 'classnames/bind';

const cx = classNames.bind();

const GridBulkHeader = ({ defaultSortIcon = true, checked, onClick }) => {
  const columnHeaderStyle = cx({
    'grid-sort-default': defaultSortIcon
  });

  return (
    <div className={columnHeaderStyle}>
      <input
        style={{ float: 'right' }}
        type="checkbox"
        checked={checked}
        onChange={onClick}
      />
    </div>
  );
};

GridBulkHeader.propTypes = {
  defaultSortIcon: PropTypes.bool
};

export default GridBulkHeader;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/GridBulkHeader.js